import { routes } from '../../constants/strings/routes';
import {
  TOOL_PREFILL_CLIENT_ID_PARAM,
  TOOL_PREFILL_INSURER_ID_PARAM,
  TOOL_PREFILL_PARTNERSHIP_ID_PARAM,
} from './use-tool-url-prefill';

export interface ToolUrlPrefill {
  clientId?: number;
  insurerId?: number;
  /** Omit when no active contract resolves — the field is left for the operator. */
  partnershipId?: number;
}

/** A link to the billing tool with its client, insurer, and partnership seeded. */
export const buildToolUrl = ({
  clientId,
  insurerId,
  partnershipId,
}: ToolUrlPrefill): string => {
  const params = new URLSearchParams();

  if (clientId) {
    params.append(TOOL_PREFILL_CLIENT_ID_PARAM, clientId.toString());
  }

  if (insurerId) {
    params.append(TOOL_PREFILL_INSURER_ID_PARAM, insurerId.toString());
  }

  if (partnershipId) {
    params.append(TOOL_PREFILL_PARTNERSHIP_ID_PARAM, partnershipId.toString());
  }

  const search = params.toString();

  return search ? `${routes.billing.tool}?${search}` : routes.billing.tool;
};
